import { ENGLISH_LANGUAGE_TEXTS } from "./english.language";
import { FRENCH_LANGUAGE_TEXTS } from "./french.language";
import { SPANISH_LANGUAGE_TEXTS } from "./spanish.language";


export function getLanguage(languageId: LanguageId): Language {
  switch(languageId) {
    case LanguageId.SPANISH:
      return SPANISH_LANGUAGE_TEXTS;
    case LanguageId.FRENCH:
      return FRENCH_LANGUAGE_TEXTS;
    default:
      return ENGLISH_LANGUAGE_TEXTS;
  }
}

export function getLanguageFromUrl(): LanguageId {
  return <LanguageId>window.location.pathname
  .split('/')
  .find(f => f === LanguageId.ENGLISH || f === LanguageId.FRENCH || f === LanguageId.SPANISH)
  || getDefaultLanguage();
}

export function getDefaultLanguage(): LanguageId {
  const navigatorLanguage: LanguageId = <LanguageId>navigator.language.substring(0, 2);
  if(navigatorLanguage === LanguageId.ENGLISH || navigatorLanguage === LanguageId.FRENCH || navigatorLanguage === LanguageId.SPANISH){
    return navigatorLanguage
  } else {
    return LanguageId.ENGLISH
  }
}

export function changeUrlLanguage(language: LanguageId): string {
  const fragments: string[] = (window.location.pathname ).split('/');
  const idx: number = fragments
    .findIndex(f => f === LanguageId.ENGLISH || f === LanguageId.FRENCH || f === LanguageId.SPANISH);
  if(idx > -1) fragments[idx] = language;
  return fragments.join('/').replace('%3F', '?');
}

export enum LanguageId {
  SPANISH = 'es',
  ENGLISH = 'en',
  FRENCH = 'fr'
}

export interface Language {
  [textId: string]: string;
}
